import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { TextField, Button, Typography, Radio, FormControlLabel, FormControl, RadioGroup, InputLabel, Select, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import StarIcon from '@material-ui/icons/Star';
import WarningIcon from '@material-ui/icons/Warning';
import 'date-fns';
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveVisitationEVSOfflineData } from "../../offline/dataService/visitationEVSOfflineData";
import { GlobalTheme } from '../../layouts/theme';
import { Context } from "../contexts/siteContext.js";
import { Theme } from '../contexts/themeContext.js';
import { User } from '../contexts/userContext.js';
import { AssignedToUsers } from '../contexts/assignedToUsers.js';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import GridItem from "../grid/gridItem.js";
import GridContainer from "../grid/gridContainer.js";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            // marginTop: '5px',
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    highlight: {
        backgroundColor: '#f5e8d6'
    }
}));


const VisitationEVSAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const appVisitation = props.appVisitation;
    const appVisitationTypes = props.appVisitationTypes;
    const roundType = props.roundType;
    const roundOn = props.roundOn;
    const visitDate = props.visitDate;
    const location = props.location;
    const patientName = props.patientName;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { userDetail, getCurrentUserDetails } = useContext(User);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const [tempateLoaded, setTemplateLoaded] = useState(false);
    const [answersLoaded, setAnswerslLoaded] = useState(false);
    const [addVisitation, setAddVisitation] = useState(true);
    const [showReason, setShowReason] = useState(false);
    const [showRecipient, setShowRecipient] = useState(false);
    const [showAssignedUsers, setShowAssignedUsers] = useState(false);
    const [reflect, setReflect] = useState(false);
    const [showRecovery, setShowRecovery] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedRating, setSelectedRating] = useState(0);
    const [templates, setTemplates] = useState([]);
    const [defaultRecipent, setDefaultRecipent] = useState([]);
    const [defaultAssignedTo, setDefaultAssignedTo] = useState([]);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    useImperativeHandle(ref, () => {
        return {
            save: modified ? saveData : props.parentCallback
            , valueChanged: valueChanged
        };
    });

    const saveData = () => {
        saveVisitation(false);
    }

    const valueChanged = () => {
        setModified(true);
    }

    const cancel = () => {
        props.parentCallback();
    }

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const changeShowRecovery = (id, response) => {
        let index = -1;
        let q5Response = -1, q13Response = -1;

        if (id === 5) {
            q5Response = response;
            index = templates.findIndex(x => x.AppVisitationTemplateId === 13);
            q13Response = templates[index].AppVisitationTypeId;
        }
        else if (id === 13) {
            q13Response = response;
            index = templates.findIndex(x => x.AppVisitationTemplateId === 5);
            q5Response = templates[index].AppVisitationTypeId;
        }
        setShowRecovery(q5Response === 34 || q13Response === 33);
    };

    const answerChanged = (event, id, Response, IsAutoRecoveryCreation) => {
        var output = templates.filter(x => x.AppVisitationTemplateId === id);
        var status = parseInt(event.target.value);
        var index = -1;

        if (output.length > 0) {
            index = templates.findIndex(x => x.AppVisitationTemplateId === id);
            templates[index].AppVisitationTypeId = parseInt(event.target.value);
            setTemplates(templates);
            if (id === 1) setShowReason(status === 34 ? true : false);
            if (id === 12) setShowRecipient(status === 33 ? true : false);
            if (id === 13) setShowAssignedUsers(status === 33 ? true : false);
            if (id === 5 || id === 13) {
                changeShowRecovery(id, status);
            }
        }
        setReflect(!reflect);

        if (id === 1) {
            if (parseInt(event.target.value) === 34)
                setAnswersAsNA();
            else {
                index = templates.findIndex(x => x.AppVisitationTemplateId === 1);
                templates[index].ResponseId = 0;
            }
        }
        setModified(true);
    };

    const setAnswersAsNA = () => {
        templates.forEach(function (item) {
            if (item.AppVisitationTemplateId !== 1) {
                item.AppVisitationTypeId = 52;
                item.Comments = "";
            }
            if (item.AppVisitationTemplateId === 11) {
                item.Rating = 0;
                item.ResponseId = 0;
                setSelectedRating(0);
            }
            else if (item.AppVisitationTemplateId === 12) {
                setShowRecipient(false);
                item.CoachPerformersId = null;
                item.CoachPerformersName = null;
                setDefaultRecipent([]);
            }
            else if (item.AppVisitationTemplateId === 13) {
                setShowAssignedUsers(false);
                item.CoachPerformersId = null;
                item.CoachPerformersName = null;
                setDefaultAssignedTo([]);
            }
        })
    };

    const reasonSelected = (event) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === 1);
        templates[index].ResponseId = parseInt(event.target.value);
        setTemplates(templates);
        setModified(true);
        setReflect(!reflect);
    };

    const commentsChanged = (id, event) => {
        var output = templates.filter(x => x.AppVisitationTemplateId === id);
        if (output.length > 0) {
            var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
            templates[index].Comments = event.target.value;
            setTemplates(templates);
            setModified(true);
            setReflect(!reflect);
        }
    };

    const userSelected = (event, values, id) => {
        var ids = "", names = "";
        var itemIndex = templates.findIndex(x => x.AppVisitationTemplateId === id);
        for (var index = 0; index < values.length; index++) {
            ids += values[index].id + ",";
            names += values[index].firstName + " " + values[index].lastName + ",";
        }
        templates[itemIndex].CoachPerformersId = ids?.substring(0, ids.length - 1);
        templates[itemIndex].CoachPerformersName = names?.substring(0, names.length - 1);
        setTemplates(templates);
        setModified(true);
    };

    const ratingChanged = (e, id, rating) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === 11);
        templates[index].AppVisitationTypeId = id;
        templates[index].Rating = parseInt(rating);
        templates[index].ResponseId = parseInt(rating);
        setTemplates(templates);
        setSelectedRating(parseInt(rating));
        setModified(true);
    };

    const getAppVisitationTemplates = () => {
        HttpService.post('/VisitationEVS/GetAppVisitationTemplates')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationTemplates");
                result.data = offlineResult.OfflineData.data;
            }
            setTemplates(result.data);
            setTemplateLoaded(true);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationAnswers = (appVisitationId) => {
        setBackDrop(true);
        HttpService.post('/VisitationEVS/GetAppVisitationAnswers', { AppVisitation: appVisitationId })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                const data = offlineResult.OfflineData.data;

                if ((appVisitationId + "").substr(0, 1) === "$") {
                    result.data = data.filter(d => d.AppVisitationId === appVisitationId)[0].answers;
                }
                else {
                    const tempData = data.filter(d => d.AppVisitationId === appVisitationId)[0].answers;

                    if (tempData === undefined) {
                        const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationAnswers");
                        const data = offlineResult.OfflineData;
                        result.data = data.filter(d => d.AppVisitation === appVisitationId);
                    }
                    else {
                        result.data = tempData;
                    }
                }
            }
            manipulateAnswers(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const manipulateAnswers = (data) => {
        setAddVisitation(false);
        data.forEach(function (item) {
            var index = templates.findIndex(x => x.AppVisitationTemplateId === item.AppVisitationTemplateId);
            templates[index].AppVisitation = item.AppVisitation;
            templates[index].AppVisitationAnswerId = item.AppVisitationAnswerId;
            templates[index].Comments = item.Comments;
            templates[index].AppVisitationTypeId = item.AppVisitationTypeId;
            if (item.AppVisitationTemplateId === 1 && item.AppVisitationTypeId === 34) {
                templates[index].ResponseId = item.ResponseId;
                setShowReason(true);
            }
            if (item.AppVisitationTemplateId === 5 && item.AppVisitationTypeId === 34) {
                setShowRecovery(true);
            }
            if (item.AppVisitationTemplateId === 11) {
                templates[index].Rating = item.ResponseId;
                templates[index].ResponseId = item.ResponseId;
                setSelectedRating(item.ResponseId);
            }
            if (item.AppVisitationTemplateId === 12 && item.AppVisitationTypeId === 33) {
                setShowRecipient(true);
                templates[index].CoachPerformersId = item.CoachPerformersId;
                templates[index].CoachPerformersName = item.CoachPerformersName;
                let userIndex = -1;
                if (item.CoachPerformersId?.indexOf(',') > -1) {
                    let ids = item.CoachPerformersId.split(',');
                    let array = [];
                    ids.forEach(function (id) {
                        userIndex = assignedUsers.findIndex(x => x.id === parseInt(id));
                        array.push(assignedUsers[userIndex]);
                    });
                    setDefaultRecipent(array);
                }
                else {
                    userIndex = assignedUsers.findIndex(x => x.id === parseInt(item.CoachPerformersId));
                    if (userIndex > -1) setDefaultRecipent([assignedUsers[userIndex]]);
                }
            }
            if (item.AppVisitationTemplateId === 13 && item.AppVisitationTypeId === 33) {
                setShowRecovery(true);
                setShowAssignedUsers(true);
                templates[index].CoachPerformersId = item.CoachPerformersId;
                templates[index].CoachPerformersName = item.CoachPerformersName;
                let userIndex = -1;
                if (item.CoachPerformersId?.indexOf(',') > -1) {
                    let ids = item.CoachPerformersId.split(',');
                    let array = [];
                    ids.forEach(function (id) {
                        userIndex = assignedUsers.findIndex(x => x.id === parseInt(id));
                        array.push(assignedUsers[userIndex]);
                    });
                    setDefaultAssignedTo(array);
                }
                else {
                    userIndex = assignedUsers.findIndex(x => x.id === parseInt(item.CoachPerformersId));
                    if (userIndex > -1) setDefaultAssignedTo([assignedUsers[userIndex]]);
                }
            }
            setTemplates(templates);
        });
        setAnswerslLoaded(true);
    };

    const setHighlightItems = (index) => {

        if (index > -1) {
            templates[index].Highlight = true;
        }
        else {
            for (var index = 0; index < templates.length; index++) {
                var item = templates[index];
                item.Highlight = false;
                if (!item.AppVisitationTypeId && item.AppVisitationTemplateId !== 11 && item.IsRequired) {
                    item.Highlight = true;
                }
            }
        }

        setTemplates(templates);
    };

    const validate = () => {
        var roundPatientYes = false;

        if (!location[0]?.id) {
            setErrorMessage("Please select a Location");
            return false;
        }
        else if (!roundType) {
            setErrorMessage("Please select a Round Type");
            return false;
        }
        else if (roundOn === 0) {
            setErrorMessage("Please select a Round On");
            return false;
        }
        else {
            for (var index = 0; index < templates.length; index++) {
                var item = templates[index];
                item.Highlight = false;
                if (item.AppVisitationTemplateId === 1 && item.AppVisitationTypeId === 33) {
                    roundPatientYes = true;
                }
                if (!item.AppVisitationTypeId && item.AppVisitationTemplateId !== 11 && item.IsRequired) {
                    setHighlightItems(-1);
                    setErrorMessage("Please answer all questions which are marked as *");
                    return false;
                }
                else if (item.AppVisitationTypeId === 34 && item.AppVisitationTemplateId !== 12 && item.AppVisitationTemplateId !== 13) {
                    if (item.AppVisitationTemplateId === 1) {
                        if (item.ResponseId === 0 || item.ResponseId === undefined) {
                            setHighlightItems(index);
                            setErrorMessage("Please select a Reason");
                            return false;
                        }
                        if (item.Comments === '' || item.Comments === undefined || item.Comments === null) {
                            setHighlightItems(index);
                            setErrorMessage(`Please enter comments for "${item.Description}"`);
                            return false;
                        }
                    }
                    else if (item.Comments === '' || item.Comments === undefined || item.Comments === null) {
                        setHighlightItems(index);
                        setErrorMessage(`Please enter comments for "${item.Description}"`);
                        return false;
                    }
                }
                else if (roundPatientYes && item.AppVisitationTemplateId === 11 && item.IsRequired) {
                    if (item.Rating === undefined || item.Rating === null || parseInt(item.Rating) === 0) {
                        setHighlightItems(index);
                        setErrorMessage("Please select the Ratings");
                        return false;
                    }
                    if (parseInt(item.Rating) < 4 && (item.Comments === '' || item.Comments === undefined || item.Comments === null)) {
                        setHighlightItems(index);
                        setErrorMessage(`Please enter comments for "${item.Description}"`);
                        return false;
                    }
                }
                else if (item.AppVisitationTemplateId === 12 && item.AppVisitationTypeId === 33 && (item.CoachPerformersId === '' || item.CoachPerformersId === undefined || item.CoachPerformersId === null)) {
                    setHighlightItems(index);
                    setErrorMessage("Please enter Recipients");
                    return false;
                }
                else if (item.AppVisitationTemplateId === 12 && item.AppVisitationTypeId === 33 && (item.Comments === undefined || item.Comments === '' || item.Comments === null)) {
                    setHighlightItems(index);
                    setErrorMessage("Please enter comments for Recipents");
                    return false;
                }
                else if (item.AppVisitationTemplateId === 13 && item.AppVisitationTypeId === 33 && (item.CoachPerformersId === '' || item.CoachPerformersId === undefined || item.CoachPerformersId === null)) {
                    setHighlightItems(index);
                    setErrorMessage("Please enter Assigned users");
                    return false;
                }
                else if (item.AppVisitationTemplateId === 13 && item.AppVisitationTypeId === 33 && (item.Comments === undefined || item.Comments === '' || item.Comments === null)) {
                    setHighlightItems(index);
                    setErrorMessage("Please enter comments for Assigned To");
                    return false;
                }
            }
        }
        return true;
    };

    const saveVisitation = (goToRecovery) => {
        var model = [];
        var valid = validate();

        if (!valid) {
            setOpenError(true);
            return;
        }
        else {
            setBackDrop(true);
            if (addVisitation) {
                model = {
                    AppVisitationId: 0,
                    SiteId: defaultSite.id,
                    GeoLocation: location[0].id,
                    GeoLocationAncestor: location[0].aid,
                    VisitDate: visitDate,
                    PatientName: patientName,
                    RoundOn: roundOn,
                    RoundType: roundType,
                    Rounder: userDetail.PplPeoFirstName + " " + userDetail.PplPeoLastName
                }
                TransactionTime.end();
                TransactionTime.updateData(model);
            } else {
                model = appVisitation;
                model.PatientName = patientName;
                model.RoundOn = roundOn;
                model.RoundType = roundType;
                model.GeoLocation = location[0].id;
                model.GeoLocationAncestor = location[0].aid;
            }

            HttpService.post('/VisitationEVS/SaveAppVisitation', model)
            .then(async result => {
                if (result && result.offline) {
                    model.VisitDateString = model.VisitDate;
                    model.answers = templates;
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                    const data = offlineResult.OfflineData.data;
                    const tempData = data.filter(d => d.AppVisitationId === model.AppVisitationId)[0]?.recoveries;

                    if (tempData !== undefined) {
                        model.recoveries = tempData;
                    }

                    var indexedDBId = await SaveVisitationEVSOfflineData(defaultSite.id, model.AppVisitationId, "SaveAppVisitation", model, "/VisitationEVS/SaveAppVisitation", false, false);
                    if (model.AppVisitationId === 0)
                        model.AppVisitationId = "$" + indexedDBId;
                        
                    if (addVisitation && showRecovery) {
                        goToRecovery = true;
                    }
                    setBackDrop(false);
                    props.refreshGrid(model, goToRecovery);
                }
                else {
                    saveAnswers(result.data, goToRecovery);
                }
            },
            (error) => {
                console.log(error);
            });
        }
    };

    const saveAnswers = (data, goToRecovery) => {
        if (addVisitation) {
            if (showRecovery)
                goToRecovery = true;
            templates.forEach(function (item) {
                item.AppVisitation = data.AppVisitationId;
            })
        }
        HttpService.post('/VisitationEVS/SaveAppVisitationAnswer', templates)
        .then(async result => {
            data.answers = result.data;
            await SaveVisitationEVSOfflineData(defaultSite.id, data.AppVisitationId, "SaveAppVisitation", data, "/VisitationEVS/SaveAppVisitation", true, false);
            setBackDrop(false);
            props.refreshGrid(data, goToRecovery);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getAppVisitationTemplates();
        if (assignedUsers.length === 0 || assignedUsers[0].uniBrief !== defaultSite.houseCode.toString()) {
            getAssignedToUsers();
        }
        if (userDetail.length === 0)
            getCurrentUserDetails();
        if (props.model.length === 0) {
            TransactionTime.begin('VisitationEVS');
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (appVisitation.length === 0) {
            setAnswerslLoaded(true);
        }
        else if (appVisitation !== null && templates?.length > 0) {
            getAppVisitationAnswers(appVisitation.AppVisitationId);
        }
        // eslint-disable-next-line 
    }, [tempateLoaded]);

    return (<>
        <Backdrop className={classes.backdrop} id="addVisitationBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        {answersLoaded && <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => saveVisitation(false)} reflectchanges={reflect.toString()}>
                            {templates.length > 0 && templates.map((template, key) => {
                                return (<div key={template.AppVisitationTemplateId} className={template.Highlight == true ? classes.highlight : '' }>
                                    <Typography variant="subtitle1" style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>
                                        <span style={{ color: "red", fontSize: "18px" }}>{template.IsRequired ? "* " : ""}</span>
                                        {template.Description}
                                    </Typography>
                                    {template.AppVisitationTemplateId === 13 &&
                                        <div>
                                        {
                                            appVisitationTypes.followUps.map((option, key) => {
                                                return (<Typography key={option.AppVisitationTypeId} variant="subtitle1"
                                                    style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>
                                                    * {option.Title}
                                                </Typography>
                                                )
                                            })
                                        }
                                        </div>
                                    }
                                    {template.QuestionType === 'YesNo' &&
                                        (<>
                                            <div>
                                                <FormControl component="fieldset">
                                                    <RadioGroup aria-label="yesNo" name="yesNo" style={{ display: 'block' }}
                                                        value={template.AppVisitationTypeId || ''}
                                                        onChange={(e) => answerChanged(e, template.AppVisitationTemplateId, template.AppVisitationTypeId, template.IsAutoRecoveryCreation)}>
                                                        {appVisitationTypes.yesNo.map((option, key) => {
                                                            return (
                                                                <FormControlLabel value={option.AppVisitationTypeId} key={option.AppVisitationTypeId}
                                                                    id={`radio${template.AppVisitationTemplateId}_${option.Title}`}
                                                                    control={<Radio checked={template.AppVisitationTypeId === option.AppVisitationTypeId} style={{ color: currentTheme.secondary }} />}
                                                                    label={option.Title} style={{ color: currentTheme.text }} />
                                                            )
                                                        })
                                                        }
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                            {template.AppVisitationTemplateId === 1 && showReason &&
                                                <FormControl variant="outlined" margin="dense" style={{ width: '100%' }}>
                                                    <InputLabel htmlFor="Reason">Reason</InputLabel>
                                                    <Select fullWidth
                                                        native
                                                        label="Reason"
                                                        size="small"
                                                        value={template.ResponseId}
                                                        onChange={(e) => { reasonSelected(e) }}
                                                    >
                                                        <option aria-label="None" key="0" value="0" />
                                                        {
                                                            appVisitationTypes.reasons.map((option, key) => {
                                                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                                            })
                                                        }
                                                    </Select>
                                                    <br />
                                                </FormControl>
                                            }
                                            {template.AppVisitationTemplateId === 12 && showRecipient === true &&
                                                <>
                                                    <Autocomplete
                                                        disablePortal={true}
                                                        multiple
                                                        size="small"
                                                        id="Recipients"
                                                        options={assignedUsers}
                                                        getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
                                                        defaultValue={defaultRecipent}
                                                        filterSelectedOptions
                                                        onChange={(e, v) => userSelected(e, v, 12)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                label="Recipients"
                                                                placeholder="Recipients"
                                                            />
                                                        )}
                                                    />
                                                    <br />
                                                </>
                                            }
                                            {template.AppVisitationTemplateId === 13 && showAssignedUsers === true &&
                                                <>
                                                    <Autocomplete
                                                        disablePortal={true}
                                                        multiple
                                                        size="small"
                                                        id="AssignedTo"
                                                        options={assignedUsers}
                                                        getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
                                                        defaultValue={defaultAssignedTo}
                                                        filterSelectedOptions
                                                        onChange={(e, v) => userSelected(e, v, 13)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                label="Assigned To"
                                                                placeholder="Assigned Users"
                                                                value={params.firstName}
                                                            />
                                                        )}
                                                    />
                                                    <br />
                                                </>
                                            }
                                            <TextField fullWidth
                                                size="small"
                                                label="Comments"
                                                variant="outlined"
                                                value={template.Comments || ""}
                                                onChange={e => commentsChanged(template.AppVisitationTemplateId, e)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <br /> <br />
                                        </>
                                    )}
                                    {template.QuestionType === 'Rating' &&
                                        <>
                                            <div className="star-all">
                                                {appVisitationTypes.ratings.map((rating, key) => {
                                                    return (
                                                        <StarIcon key={rating.AppVisitationTypeId}
                                                            onClick={e => ratingChanged(e, rating.AppVisitationTypeId, rating.Title)}
                                                            className={parseInt(rating.Title) <= selectedRating ? 'star-selected' : 'star'}
                                                        />
                                                    )
                                                })}
                                            </div>
                                            <br />
                                            {template.Rating <= 3 && <TextField fullWidth
                                                id="RatingComments"
                                                label="Comments"
                                                variant="outlined"
                                                size="small"
                                                value={template.Comments}
                                                onChange={e => commentsChanged(template.AppVisitationTemplateId, e)}
                                            />
                                            }
                                            <br /> <br />
                                        </>
                                    }
                                </div>
                                )
                            })
                        }
                        <br></br>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.button}
                            style={{ background: currentTheme.secondary, width: "100px" }}
                            startIcon={<SaveIcon />}
                            type="submit"
                            onSubmit={() => saveVisitation(false)}
                        >
                            Save
                        </Button>
                        {showRecovery &&
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "120px", marginRight: "10px" }}
                                startIcon={<WarningIcon />}
                                type="button"
                                onClick={() => saveVisitation(true)}
                            >
                                Recovery
                            </Button>
                        }
                        </ValidatorForm>
                    }
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        {(props.model.length === 0) && (
            <InactiveTimeout disContinue={cancel} />
        )}
    </>
    )
});
export default VisitationEVSAdd;
